export default class AdminNotificacionForm {
    /**
     *
     * @param {callback} options.onSuccess
     */
    nuevo(options) {
        let myself = this;
        let modalOpts = {
            title: 'Nueva notificación',
            method: 'POST',
            url: '/api/admin/notificaciones'
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        const ahora = new Date();
        const inicio = new Date(ahora.getFullYear(), 0, 1, 0, 0, 0);
        ahora.setHours(15);
        ahora.setMinutes(0);
        let data = {
            anho: ahora.getFullYear(), nombre: 'Corte al ' + Fecha.formatTextDate(ahora), observaciones: '', inicio: Fecha.formatInput(inicio), fin: Fecha.formatInput(ahora)
        };
        this.modal.render(this.render(data));
    }

    /**
     * @param {number} id
     * @param {callback} options.onSuccess
     */
    editar(id, options) {
        let myself = this;
        let modalOpts = {
            title: 'Editar notificación',
            method: 'PUT',
            url: `/api/admin/notificaciones/${id}`
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        Ajax.get(`/api/admin/notificaciones/${id}`, {
            then: function (response) {
                response.data.inicio = Fecha.formatInput(new Date(response.data.inicio));
                response.data.fin = Fecha.formatInput(new Date(response.data.fin));
                myself.modal.render(myself.render(response.data));
            }
        });
    }

    render(data) {
        console.log(data);
        const anhoActual = (new Date()).getFullYear();
        let optAnhos = '';
        for (let anho = anhoActual; anho >= 2022; anho--) {
            let selectedAnho = (anho == data.anho) ? 'selected="selected"' : '';
            optAnhos += `<option value="${anho}" ${selectedAnho}>${anho}</option>`;
        }

        let html = `<div class="row form-group my-1">
        <label for="anho" class="col-form-label col col-md-4">Año</label>
        <div class="col col-md-8">
            <select name="anho" id="anho" class="form-select form-select-sm" required>
            ${optAnhos}
            </select>
        </div>
    </div>
        <div class="row form-group my-1">
            <label for="nombre" class="col-form-label col col-md-4">Nombre</label>
            <div class="col col-md-8">
                <input type="text" value="${data.nombre}" id="nombre" name="nombre" class="form-control form-control-sm" required maxlength="200"/>
            </div>
        </div>
        <div class="row form-group my-1">
            <label for="observaciones" class="col-form-label col col-md-4">Observaciones</label>
            <div class="col col-md-8">
                <input type="text" value="${data.observaciones}" id="observaciones" name="observaciones" class="form-control form-control-sm" required maxlength="200"/>
            </div>
        </div>
        <div class="row form-group my-1">
            <label for="inicio" class="col-form-label col col-md-4">Desde</label>
            <div class="col col-md-8">
                <input type="datetime-local" value="${data.inicio}" id="inicio" name="inicio" class="form-control form-control-sm" required maxlength="200"/>
            </div>
        </div>
        <div class="row form-group my-1">
            <label for="fin" class="col-form-label col col-md-4">Hasta</label>
            <div class="col col-md-8">
                <input type="datetime-local" value="${data.fin}" id="fin" name="fin" class="form-control form-control-sm" required maxlength="200"/>
            </div>
        </div>`;
        return `<form>${html}</form>`;
    }
}
